// context/ClientNameContext.js
import React, { createContext, useState } from "react";

export const ClientNameContext = createContext();

export const ClientNameProvider = ({ children }) => {
  const [clientName, setClientName] = useState("");

  return (
    <ClientNameContext.Provider value={{ clientName, setClientName }}>
      {children}
    </ClientNameContext.Provider>
  );
};
